import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {ScribeArtifact} from '@github-ui/scribe-artifacts'

const ISSUE_ARTIFACTS_FEATURE_FLAG = 'issue_artifacts_section'

export function issueArtifactsFeatureEnabled(): boolean {
  return isFeatureEnabled(ISSUE_ARTIFACTS_FEATURE_FLAG)
}

export function shouldFetchIssueArtifacts(resourceId: number): boolean {
  return issueArtifactsFeatureEnabled() && resourceId > 0
}

export function shouldShowArtifactsSection(artifacts: ScribeArtifact[] | undefined): boolean {
  return issueArtifactsFeatureEnabled() && Boolean(artifacts?.length)
}

export function shouldShowCreateArtifactButton(artifacts: ScribeArtifact[] | undefined): boolean {
  return issueArtifactsFeatureEnabled() && Array.isArray(artifacts) && artifacts.length === 0
}
